export const mapperResponseToList = (list, showDraft) => {
  let listMapped = [];

  list.forEach((news) => {
    if (
      news.state === "PUBLISH_NO_DRAFT" ||
      (news.state === "PUBLISH_WITH_DRAFT" && !showDraft)
    ) {
      listMapped.push({
        id: news.id,
        images: news?.publishContent?.mainMultimedia,
        title: news?.publishContent?.title,
        date: news?.publishContent?.date,
        locale: news?.locale,
        state: news.state,
      });
    } else {
      listMapped.push({
        id: news.id,
        images: news?.draftContent?.mainMultimedia,
        title: news?.draftContent?.title,
        date: news?.draftContent?.date,
        locale: news?.locale,
        state: news.state,
      });
    }
  });

  return listMapped;
};
